import { createContext, useContext, useEffect, useState } from "react";
import * as api from "./api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // CRITICAL: If returning from OAuth callback (session_id in URL fragment),
    // skip the /me check — AuthCallback will exchange the session_id first.
    if (typeof window !== "undefined" && window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    const token = api.getToken();
    if (!token) { setLoading(false); return; }
    api.me().then(setUser).catch(() => api.setToken(null)).finally(() => setLoading(false));
  }, []);

  async function login(email, password) {
    const u = await api.login({ email, password });
    setUser(u);
    return u;
  }
  async function register(payload) {
    const u = await api.register(payload);
    setUser(u);
    return u;
  }
  function logout() {
    api.setToken(null);
    setUser(null);
  }

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout, setUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
